<div class="import-profiles">
  <h1>Імпорт профілів</h1>

  <mat-card class="import-profiles__card">
    <h2>1. Завантаження файлу</h2>

    <div
      class="import-profiles__dropzone"
      (click)="fileInput.click()"
      (keyup.enter)="fileInput.click()"
      (keyup.space)="fileInput.click()"
      (dragover)="onDragOver($event)"
      (drop)="onDrop($event)"
      tabindex="0"
      role="button"
      aria-label="Перетягніть файл сюди або натисніть, щоб вибрати"
    >
      <input #fileInput type="file" accept=".xlsx,.xls" (change)="onFileSelected($event)" hidden />
      <mat-icon>cloud_upload</mat-icon>
      @if (selectedFileName()) {
        <p>
          Обраний файл:
          <strong>{{ selectedFileName() }}</strong>
        </p>
      } @else {
        <p>Перетягніть файл сюди або натисніть, щоб вибрати</p>
      }
    </div>

    @if (analyzeResult()) {
      <div class="import-profiles__info">
        <p>
          Рядків для імпорту:
          <strong>{{ analyzeResult().total }}</strong>
        </p>
      </div>
    }
  </mat-card>
  @if (analyzeResult()) {
    <mat-card class="import-profiles__card">
      <h2>2. Вибір порталу</h2>

      <div class="import-profiles__actions">
        <mat-form-field appearance="outline" class="import-profiles__portal-select">
          <mat-label>Портал</mat-label>
          <mat-select [formControl]="portalControl">
            @for (portal of portals(); track portal.id) {
              <mat-option [value]="portal.id">
                {{ portal.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </mat-card>

    <mat-card class="import-profiles__card">
      <h2>3. Мапінг колонок</h2>

      <div class="import-profiles__mapping-header">
        <span>Колонка в Excel</span>
        <span>Поле профілю</span>
      </div>

      @for (column of analyzeResult().columns; track column) {
        <div class="import-profiles__mapping-row">
          <span class="import-profiles__mapping-column">{{ column }}</span>
          <mat-form-field appearance="outline" class="import-profiles__mapping-select">
            <mat-label>Поле профілю</mat-label>
            <mat-select [formControl]="getMappingControl(column)">
              <mat-option [value]="''">— Пропустити —</mat-option>
              @for (field of profileFields(); track field.key) {
                <mat-option [value]="field.key">
                  {{ field.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </mat-card>

    <mat-card class="import-profiles__card">
      <h2>4. Параметри імпорту та старт</h2>

      <div class="import-profiles__conversion">
        <h3>Конвертувати з рядка</h3>
        <div class="import-profiles__conversion-list">
          @for (field of convertibleProfileFields; track field.key) {
            <mat-checkbox [formControl]="getConvertFromStringControl(field.key)">
              {{ field.label }}
            </mat-checkbox>
          }
        </div>
      </div>

      <div class="import-profiles__actions">
        <button mat-raised-button color="primary" (click)="onImport()" [disabled]="!canImport() || loading()">
          @if (loading()) {
            <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
          } @else {
            <span>Імпортувати</span>
          }
        </button>
      </div>

      @if (importResult()) {
        <div class="import-profiles__result">
          <p>
            Всього рядків:
            <strong>{{ importResult()!.total }}</strong>
          </p>
          <p>
            В черзі:
            <strong>{{ importResult()!.enqueued || 0 }}</strong>
          </p>
          <p>
            Некоректних:
            <strong>{{ importResult()!.invalid }}</strong>
          </p>

          @if (importResult()!.errors.length) {
            <div>
              <h3>Помилки</h3>
              <ul>
                @for (error of importResult()!.errors; track error.row) {
                  <li>
                    Рядок {{ error.row }}:
                    {{ error.errors.join(', ') }}
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      }
    </mat-card>
  }
</div>
